import { UserTypeEnum } from '@kurotetsu/share/constants';
import { AuthProvider } from '@kurotetsu/share/context/AuthContext';
import { firebaseAuth } from '@kurotetsu/agent/vendors/firebase';
import React from 'react';
import { RouterProvider } from 'react-router-dom';
import router from '@kurotetsu/agent/routes';

const App: React.FC = () => {
  return (
    <AuthProvider firebaseAuth={firebaseAuth} userType={UserTypeEnum.Agency}>
      <RouterProvider router={router} />
    </AuthProvider>
  );
};

export default App;
